/* unplugin-vue-components disabled */import { render } from "./RoleList.vue?vue&type=template&id=a2d03ffe&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"

import "./RoleList.vue?vue&type=style&index=0&id=a2d03ffe&scoped=true&lang=css"

import exportComponent from "D:\\work\\arc_frontend\\arctenantorg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d03ffe"]])

export default __exports__